import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { SessionStorageService } from 'ngx-webstorage'; 
@Component({
  selector: 'cbic-departmental-office',
  templateUrl: './departmental-office.component.html',
  styleUrls: ['./departmental-office.component.scss']
})
//export class DepartmentalOfficeComponent implements OnInit {
export class DepartmentalOfficeComponent implements OnInit {

  usedLanguage:any;
  color:any;

  constructor(private sessionStorageService: SessionStorageService, private changeLnService: ChangeLanguageService) { }

  ngOnInit(): void {
    this.usedLanguage = this.changeLnService.getLanguage();
    this.color = this.sessionStorageService.retrieve('colr');
  }
}
  